<template>
    <div>
        <title-bar :title="$t('我的广告')" />
        <van-list v-model="loading" :finished="finished" :finished-text="$t('没有更多了')" @load="onLoad">
            <div v-for="item in items" :key="item.id" class="ad-card-box">
                <van-card :tag="item.tag" :title="`${item.typeInfo.name} #${item.id}`" :desc="item.typeInfo.summary"
                    @click="onEdit(item)" class="card-item">
                    <!-- <template #tags>
                        <van-tag plain type="danger">城市</van-tag>
                        <van-tag plain type="danger">电话</van-tag>
                        <van-tag plain type="danger">类型</van-tag>
                    </template> -->
                    <template #thumb>
                        <van-image fit="fill" :src="item.typeInfo.logoUrl" />
                    </template>
                </van-card>
                <van-cell :value="item.stateText" :class="{ 'marked-text': item.state == 3 }">
                    <template #title>
                        <!-- <span class="van-cell__title" style="margin-right: .5rem;">{{ $t("状态") }}</span> -->
                        <div class="reserve-tags">
                            <van-tag v-if="item.payState == 0" type="danger">{{ $t("未付费") }}</van-tag>
                            <van-tag v-else type="success">{{ $t("已付费") }}</van-tag>

                            <van-tag type="success">{{ $enums.reservePayType.toName(item.payType) }}</van-tag>
                        </div>
                    </template>
                </van-cell>
                <van-cell v-show="item.price && item.price > 0" :title='$t("广告价格")'
                    :value="item.price | priceToDisplay(true)" />
                <van-cell v-show="!!item.payTime" :title='$t("付费时间")'
                    :value="item.payTime | formatDateTime('yyyy-MM-dd')" />
                <van-cell :title='$t("到期时间")' :value="item.endTime | formatDateTime('yyyy-MM-dd')" />
                <van-cell style="text-align: right">
                    <template #title>
                        <van-button @click.stop="onEdit(item)" type="primary" size="mini" round>{{
                            $t("修改广告")
                        }}</van-button>
                        <van-button @click.stop="onViewAdResult(item)" size="mini" round>{{
                            $t("查看广告")
                        }}</van-button>
                    </template>
                </van-cell>
            </div>
        </van-list>

        <van-popup v-model="resultView.show" position="bottom" round>
            <div class="van-picker__toolbar">
                <div class="van-picker__cancel"></div>
                <div class="van-ellipsis van-picker__title">{{ $t("查看结果") }}</div>
                <div class="van-picker__confirm"></div>
            </div>

            <div :key="item.siteId" v-for="item in resultView.sites">
                <h2 class="block-title">{{ item.site.name }}</h2>
                <van-field v-model="item.adUrl" readonly center :label="$t('广告链接')">
                    <template #button>
                        <van-button v-if="item.adUrl && item.adUrl.length > 0" size="small" type="primary"
                            native-type="button" @click="onOpenAdUrl(item)">{{ $t("打开") }}</van-button>
                    </template>
                </van-field>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Button, List, Card, Tag, Popup, Field, Picker, Image, Cell } from "vant";
import TitleBar from "../../components/title-bar.vue";

export default {
    components: {
        TitleBar,
        [Button.name]: Button,
        [List.name]: List,
        [Card.name]: Card,
        [Tag.name]: Tag,
        [Popup.name]: Popup,
        [Field.name]: Field,
        [Image.name]: Image,
        [Cell.name]: Cell,
        [Picker.name]: Picker, //这里只使用它的样式
    },

    data() {
        return {
            loading: false,
            finished: false,
            items: [],
            resultView: {
                show: false,
                sites: [],
            },
        };
    },
    methods: {
        async onLoad() {
            let res = await this.$userApi.reserve.getMyReserves();
            this.loading = false;
            if (res.status == 200) {
                for (let itm of res.data.items) {
                    this.handleItem(itm);
                    this.items.push(itm);
                }
                this.finished = true;
            }
        },
        handleItem(item) {
            item.tag = item.type == 2 ? this.$t("套餐") : null;
            item.stateText = this.$enums.reserveState.toName(item.state);
        },
        async onViewAdResult(item) {
            this.resultView.show = true;
            let res = await this.$userApi.reserve.getReserveDetail({ id: item.id });
            if (res.status == 200) {
                this.resultView.sites = res.data.reserveInfos;
            }
        },
        onOpenAdUrl(item) {
            window.open(item.adUrl, "_blank");
        },
        onEdit(item) {
            this.$router.push({
                path: "/reserve/update",
                query: {
                    type: item.type,
                    id: item.id,
                },
            });
        },
    },
};
</script>

<style lang="less" scoped>
.reserve-tags {
    width: auto;

    .van-tag {
        margin-right: .1rem;
    }
}

.marked-text {
    color: red;
    font-weight: bold;

    .van-cell__value {
        color: red;
        font-weight: bold;
    }
}
</style>